import axios from "axios";

export const callGmailAPI = async (path, body) =>
    await axios.post(
        // `http://10.0.0.161:8080/api/${path}`,
        `https://leadmanager-express-backend.ue.r.appspot.com/api/${path}`,
        body
    ); 